import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Input,
  Col,
  Form,
  FormGroup,
  Label,
  CardFooter
} from "reactstrap";
import Select from "react-select";

import axios from "axios";

import { Redirect } from "react-router-dom";

import { 
  PanelHeader, 
  Button,
  Stats,
  Statistics
 } from "components";

import { thead, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
import { dashboardPanelChart } from "variables/charts.jsx";

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};

const ESTADO_FACTURA = "estado-factura";
const ENVIO = "envio";
const NOTA = "nota";
const INTERNET = "internet";
const AGREGAR_MOVIL = "agregar-movil";
const GASTO_EXTRA = "gasto-extra";

const PILL_TODAS = "todas";
const PILL_DEVUELTAS = "devueltas";
const PERMISSIONS = [
  118946,
  118060,
  469,
  1
];

const formatterCurrency = new Intl.NumberFormat("de-DE", {
  style: 'currency',
  currency: 'EUR'
});

class CashRegistersList extends React.Component {
  constructor(props) {
    super(props);
    if (!props.userData.isBillingDepartmentN1()) this.redirectTo("/dashboard");
    this.state = {
      downloading: {},
      showDetail: false,
      orderDetail: null,
      ordersChartReady: false,
      ordersHistoryTitle: "Histórico de facturas",
      toDashboard: false,
      searchQuery: "",
      showPopUp: false,
      popUpConfirmation: null,
      popUpToShow: null,
      currentBillStatus: null,
      currentBillID: "",
      currentBillNumber: "",
      currentPill: PILL_TODAS
    };
    ////console.log(props);
    this.viewOrderArticles = this.viewOrderArticles.bind(this);
    this.loadOrdersChart = this.loadOrdersChart.bind(this);
    this.getViewArticlesButton = this.getViewArticlesButton.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.searchBills = this.searchBills.bind(this);
    this.createPopUp = this.createPopUp.bind(this);
    this.createBillStatusPopUp = this.createBillStatusPopUp.bind(this);
    this.editBillStatusConfirmation = this.editBillStatusConfirmation.bind(this);
    this.hidePopUpConfirmation = this.hidePopUpConfirmation.bind(this);
    this.paymentStatus = this.paymentStatus.bind(this);
    this.openBillStatusPopUpFromBill = this.openBillStatusPopUpFromBill.bind(this);
    this.showPopUp = this.showPopUp.bind(this);
    this.createNavigationPills = this.createNavigationPills.bind(this);

    this.createCashRegistersList = this.createCashRegistersList.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
  }
  componentDidMount() {
    this.props.getCashRegistersList();
  }
  createPopUp() {
    // console.log("############# CREATING POPUP #############");
    // console.log(this.state);
    // console.log(this.props.mainState);
    switch (this.state.popUpToShow) {
      case ESTADO_FACTURA:
        return this.createBillStatusPopUp();
      case ENVIO:
        return this.createDeliveryPopUp();
      case NOTA:
        return this.createNotePopUp();
      case INTERNET:
        return this.configureInternetPopUp();
      case AGREGAR_MOVIL:
        return this.addMobilePopUp();
      case GASTO_EXTRA:
        return this.createExtraExpensePopUp();
      default:
        //console.log("################## ERROR CREATE POPUP ################");
        //console.log("POPUP TO SHOW NOT SPECIFIED");
        return;
    }
  }
  createBillStatusPopUp() {
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Editar estado"
        onConfirm={() => this.showPopUpConfirmation(ESTADO_FACTURA)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Guardar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Estado</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Estado"
                  name="estado"
                  value={this.state.currentBillStatus}
                  options={this.props.mainState.billStatuses.forOptions}
                  onChange={value =>
                    this.setState({ currentBillStatus: value })
                  }
                />
                <br></br>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  showPopUpConfirmation(tipo) {
    switch (tipo) {
      case NOTA:
        this.newNoteConfirmation();
        break;
      case ESTADO_FACTURA:
        this.editBillStatusConfirmation();
        break;
      case ENVIO:
        this.newDeliverySIMConfirmation();
        break;
      case INTERNET:
        this.configureInternetConfirmation();
        break;
      case AGREGAR_MOVIL:
        this.addMobile();
        break;
      case GASTO_EXTRA:
        this.newExtraExpenseConfirmation();
        break;
      default:;
    }
  }
  editBillStatusConfirmation() {
    this.props.editBill(
      this.state.currentBillID,
      this.state.currentBillStatus.value,
      this.state.currentBillNumber
    );
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Estado editado!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          El estado ha sido editado.
        </SweetAlert>
      )
    });
  }
  openBillStatusPopUpFromBill(order) {
    console.log("################## OPEN BILL STATUS ################");
    console.log(order);
    let billID = order.order_id;
    let billStatus = order.estado_pedido;
    let billNumber = order.numero_pedido;
    let _currentBillStatus = null;
    this.props.mainState.billStatuses.forOptions.map(currentStatus => {
      if (currentStatus.label === billStatus)
        _currentBillStatus = currentStatus;
    });
    this.setState({
      currentBillID: billID,
      currentBillStatus: _currentBillStatus,
      currentBillNumber: billNumber
    });
    this.showPopUp(ESTADO_FACTURA);
  }
  showPopUp(tipo) {
    // console.log("######### OPCIONES ###########");
    // console.log(this.props.mainState);
    this.setState({
      popUpToShow: tipo,
      showPopUp: true,
      popUpConfirmation: null
    });
  }
  hidePopUpConfirmation() {
    this.setState({
      popUpConfirmation: null
    });
  }
  loadOrdersChart() {
    let ordersChartDates = [];
    let ordersChartTotals = [];
    let partialOrders = [];
    /* if(this.props.mainState.orders.length > this.state.ordersToDisplayInChart) {
      partialOrders = this.props.mainState.orders.slice(0,this.state.ordersToDisplayInChart).reverse();
    }else{ */
      partialOrders = this.props.mainState.orders.slice(0).reverse();
    /* } */
    partialOrders.map((currentOrder, key) =>{
      ordersChartDates.push(
        new Intl.DateTimeFormat("es-ES", {
          year: "numeric",
          month: "short"
        })
          .format(Date.parse(currentOrder.fecha))
          .replace(".", "")
      );
      ordersChartTotals.push(
        parseFloat(
          currentOrder.total
            .replace(",", ".")
            .substring(0, currentOrder.total.length - 2)
        )
      );
    });

    let ordersChart = {
      data: canvas => {
        const ctx = canvas.getContext("2d");
        var chartColor = "#FFFFFF";
        var gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
        gradientStroke.addColorStop(0, "#80b6f4");
        gradientStroke.addColorStop(1, chartColor);
        var gradientFill = ctx.createLinearGradient(0, 200, 0, 50);
        gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
        gradientFill.addColorStop(1, "rgba(255, 255, 255, 0.14)");
    
        return {
          labels: ordersChartDates,
          datasets: [
            {
              label: "Total",
              borderColor: chartColor,
              pointBorderColor: chartColor,
              pointBackgroundColor: "#2c2c2c",
              pointHoverBackgroundColor: "#2c2c2c",
              pointHoverBorderColor: chartColor,
              pointBorderWidth: 1,
              pointHoverRadius: 7,
              pointHoverBorderWidth: 2,
              pointRadius: 5,
              fill: true,
              backgroundColor: gradientFill,
              borderWidth: 2,
              data: ordersChartTotals
            }
          ]
        };
      },
      options: {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0
          }
        },
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: "#fff",
          titleFontColor: "#333",
          bodyFontColor: "#666",
          bodySpacing: 4,
          xPadding: 12,
          mode: "nearest",
          intersect: 0,
          position: "nearest"
        },
        legend: {
          position: "bottom",
          fillStyle: "#FFF",
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,

                // Return an empty string to draw the tick line but hide the tick label
                // Return `null` or `undefined` to hide the tick line entirely
                userCallback: function(value, index, values) {
                    // Convert the number to a string and splite the string every 3 charaters from the end
                    value = value.toString();
                    value = value.split(/(?=(?:...)*$)/);
        
                    // Convert the array to a string and format the output
                    value = value.join('.');
                    return value + ' €';
                }
              },
              gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)"
              },
              ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold"
              }
            }
          ]
        }
      }
    };

    let firstOrderDate = 
      new Intl.DateTimeFormat("es-ES", {
        year: "numeric",
        month: "short"
      })
        .format(Date.parse(partialOrders[0].fecha))
        .replace(".", "");
    let lastOrderDate = 
      new Intl.DateTimeFormat("es-ES", {
        year: "numeric",
        month: "short"
      })
        .format(Date.parse(partialOrders[partialOrders.length-1].fecha))
        .replace(".", "");

    this.setState({
      ordersChartReady: true,
      ordersChart: ordersChart,
      ordersHistoryTitle: "Histórico de facturas (" + firstOrderDate + " - " + lastOrderDate + ")"
    });
  }
  downloadBill(url, orderNumber, event){
    this.setState({
      [orderNumber]: true
    });
    axios({
      url: url,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        "download",
        "factura_nadunet_".concat(orderNumber).concat(".pdf")
      );
      document.body.appendChild(link);
      link.click();
      this.setState({
        [orderNumber]: false
      });
    });
  }
  hideAlert() {
    this.setState({
      showPopUp: false
    });
  }
  goToDashboard() {
    this.setState({
      toDashboard: true
    });
  }
  paymentStatus(order){
    let statusReady = null;
    let payment = order.estado_pedido;
    let statusButtonColor = "default";
    let statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    if (payment.includes("Pendiente")) {
      statusButtonColor = "warning";
      statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    } else if(payment.includes("Pagada")){
      statusButtonColor = "primary";
      statusButtonIcon = "now-ui-icons ui-1_check";
    } else if(payment.includes("Procesando")){
      statusButtonColor = "info";
      statusButtonIcon = "now-ui-icons arrows-1_refresh-69 spin";
    } else /*if(payment.includes("Recibo"))*/{
      statusButtonColor = "danger";
      statusButtonIcon = "now-ui-icons ui-1_simple-remove";
    }

    statusReady =                   
    <Button
      color={statusButtonColor}
      size="sm"
      onClick={() => {this.openBillStatusPopUpFromBill(order)}}
    >
      <i className={statusButtonIcon} /> {payment}
    </Button>;

    return statusReady;
  }
  downloadButton(order){
    let button = 
      <div>
        <i className="now-ui-icons arrows-1_cloud-download-93" /> PDF
      </div>;

    if(this.state[order]){
      button = 
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>;
    }

    return button;
  }
  viewOrderArticles(order){
    let orderDetailContent =
      <div>
        <Table responsive>
          <thead>
            <tr className="text-primary">
              <th className="text-center">
                Concepto
              </th>
              <th className="text-center">
                Precio
              </th>     
            </tr>
          </thead>
          <tbody>
            {this.props.mainState.ordersArticles[order].map((article, key) => {
              return (
                <tr key={key}>
                  <td className="text-center">{article.titulo}</td>
                  <td className="text-center">{article.total}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>;
    this.setState({
      orderDetail: orderDetailContent,
      showDetail: true
    })
  }  
  handleChange(field, event) {
    ////////console.log("Field name: " + field);
    ////////console.log("Field value: " + event.target.value);
    this.setState({ [field]: event.target.value });
  }
  getViewArticlesButton(order) {
    let button = 
      <Button
        color="default"
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" /> Ver
        </div>
      </Button>;

    if(true /*order in this.props.mainState.ordersArticles*/){
      button = 
      <Link to={"/facturas/".concat(order)}>
        <Button
          color="info"
          size="sm"
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className="now-ui-icons education_glasses" /> Ver
          </div>
        </Button>
      </Link>;
    }

    return button;
  }
  searchBills() {
    if (!this.props.mainState.isSearchingBills)
      this.props.searchBills(this.state.searchQuery, this.state.currentPill === PILL_DEVUELTAS);
  }
  createNavigationPills() {
    // console.log("CHECK PERMISSION");
    // console.log(this.props.mainState);
    if (!PERMISSIONS.includes(parseInt(this.props.mainState.user.uid))) return null;
    return (
      <div>
        <Button
          round
          key={"pill1"}
          color={this.state.currentPill === PILL_TODAS ? "primary" : "default"}
          onClick={() => {
            this.setState({currentPill: PILL_TODAS});
          }}
          leftLabel={"now-ui-icons business_money-coins"}
        >
          Todas
        </Button>
        {" "}
        <Button
          round
          key={"pill2"}
          color={this.state.currentPill === PILL_DEVUELTAS ? "danger" : "default"}
          onClick={() => {
            this.setState({currentPill: PILL_DEVUELTAS});
          }}
          leftLabel={"now-ui-icons tech_mobile"}
        >
          Devueltas
        </Button>
        {" "}
      </div>
    );
  }
  createCashRegistersList() {
    let result = null;
    let cashRegistersToDisplay = null;
    switch (this.state.currentPill) {
      case PILL_TODAS:
        cashRegistersToDisplay = this.props.mainState.cashRegisters.slice(0);
        result = this.createCashRegistersTable(cashRegistersToDisplay);
        break;
      case PILL_DEVUELTAS:
        cashRegistersToDisplay = this.props.mainState.orders.slice(0);
        result = this.createCashRegistersTable(cashRegistersToDisplay);
        break;
    }
    return result;
  }
  createCashRegistersTable(cashRegistersToDisplay) {
    let contentToDisplay = cashRegistersToDisplay.map(currentCashRegister => {
      return (
        <Col xs={12} md={4} key={currentCashRegister.id}>
          <Link to={"/cajas/".concat(currentCashRegister.id)}>
            <Card className="card-stats">
              <CardHeader>
                <CardTitle tag="h4">{currentCashRegister.name}</CardTitle>
              </CardHeader>
              <CardBody>
                <Statistics
                  // horizontal
                  icon="business_money-coins"
                  iconState="primary"
                  title={formatterCurrency.format(parseInt(currentCashRegister.amount) / 100)}
                  subtitle="Importe en caja"
                />
              </CardBody>
              <hr />
              <CardFooter>
                <Stats>
                  {[{ i: "now-ui-icons location_pin", t: currentCashRegister.office.name }]}
                </Stats>
              </CardFooter>
            </Card>
          </Link>
        </Col>
      );
    });
    return contentToDisplay;
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  render() {
    if (this.state.toDashboard === true) {
      this.redirectTo("/dashboard");
      // return <Redirect to="/dashboard" />;
    }
    //console.log()
    let contentToDisplay = null;
    let ordersToDisplay = null;
    // console.log("#################### BILLS LIST #####################");
    // console.log(this.props.mainState);
    if(this.props.mainState.cashRegistersLoaded && this.props.mainState.cashRegisters.length > 0) {
      // ordersToDisplay = this.props.mainState.orders.slice(0);
      contentToDisplay = this.createCashRegistersList();
    } else if(this.props.mainState.cashRegistersLoaded && this.props.mainState.cashRegisters.length == 0 /*&& this.props.mainState.isSearchBillResult*/) {
      contentToDisplay =
        <Row>
          <div className="text-center">
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> No hay cajas
          </div>
          <br />
        </Row>;
    } else {
      contentToDisplay =
        <Row>
          <div className="text-center">
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando cajas...
          </div>
          <br />
        </Row>;
    }
    // let navigationPills = this.createNavigationPills();
    // let navigationPillContent = this.createSelectedPillContent();

    let orderArticles = 
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title="Detalles de la factura"
        onConfirm={() => this.hideDetail()}
        showConfirm={true}
      >
        {this.state.orderDetail}
      </SweetAlert>;
    return (
      <div>
      <PanelHeader
        size="sm"
      />
        <div className="content">
          {this.state.showPopUp && this.createPopUp()}
          {this.state.popUpConfirmation}
          <Row>{contentToDisplay}</Row>
        </div>
      </div>
    );
  }
}

export default CashRegistersList;



// WEBPACK FOOTER //
// ./src/views/CashRegisters/CashRegistersList.jsx